<template>
    <div id="results">
        <step-title class="cashflow-estimate-header" step-title="Cashflow Estimate (First Year)" v-bind:class="{'hide-print': !isModalVisible}"></step-title>
        <div class="calc-row" v-bind:class="{'hide-print': !isModalVisible}">
        <div class="calc-col-one">
            <div class="annual-weekly-button-group btn-group btn-group-lg" v-bind:class="{blur: isModalVisible}" role="group" aria-label="Basic example">
                <button v-on:click="activeChoiceOne" v-bind:class="{'active-button': isActiveOne}" type="button" class="btn">WEEKLY</button>
                <button v-on:click="activeChoiceTwo" v-bind:class="{'active-button': isActiveTwo}" type="button" class="btn">ANNUAL</button>
            </div>
            <modal v-on:showCashflowEstimate="closeModal" v-show="isModalVisible"></modal>
            <tabs v-bind:class="{blur: isModalVisible}" :weekly="isActiveOne" :annual="isActiveTwo"></tabs>
        </div>
        <div class="calc-col-two fill-space">
            <complementary-analysis-box class="first-box" :phone-number="phoneNumber" :book-me-in-submit="wantsContact" v-bind:class="{blur: isModalVisible}"></complementary-analysis-box>
        </div>
        </div>
        <step-title class="equity-growth-header row-divider" step-title="Equity Growth" v-bind:class="{blur: isModalVisible, 'hide-print': !isModalVisible}"></step-title>
        <div class="calc-col-three" v-bind:class="{'hide-print': !isModalVisible}">
            <text-field-with-percentage class="capital-growth" :value="capitalGrowthValue" v-on:calc="calcCapitalGrowthValue" name="Capital-Growth" label="Average Capital Growth p.a" symbol="%" placeholder="" is-bold-font has-tooltip v-bind:class="{blur: isModalVisible}"></text-field-with-percentage>
            <equity-growth-table class="equity-growth-table" v-bind:class="{blur: isModalVisible}"></equity-growth-table>
        </div>

        <iframe id="print-template" :src="printSrc" style="border: 0; position:fixed; top:0; left:0; right:0; bottom:0; width:100%; height:100%" allow="fullscreen" v-bind:class="{'invisible-template': isModalVisible}"></iframe>
    </div>
</template>

<script>
    import axios from 'axios';
    import StepTitle from './StepTitle';
    import Tabs from './Tabs';
    import ComplementaryAnalysisBox from './ComplementaryAnalysisBox';
    import TextFieldWithSymbol from './TextFieldWithSymbol';
    import EquityGrowthTable from './EquityGrowthTable';
    import Modal from './Modal';
    import TextFieldWithPercentage from "./TextFieldWithPercentage";

    export default {
        components: {
            TextFieldWithPercentage,
            StepTitle,
            Tabs,
            ComplementaryAnalysisBox,
            TextFieldWithSymbol,
            EquityGrowthTable,
            Modal
        },
        name: "results",
        data () {
            return {
                modalVisible: true,
                isActiveOne: true,
                isActiveTwo: false
            }
        },
        computed: {
            capitalGrowthValue() {
                return this.$store.state.results.getCapitalGrowth();
            },
            weeklyRentalIncomeValue() {
                return this.$store.state.results.getWeeklyRentalIncome();
            },
            weeklyPreTotalExpensesValue() {
                return this.$store.state.results.getWeeklyPreTotalExpenses();
            },
            weeklyPreCashflowEstimateValue() {
                return this.$store.state.results.getWeeklyPreCashflowEstimate();
            },
            weeklyPostTotalClaimableExpensesValue() {
                return this.$store.state.results.getWeeklyPostTotalClaimableExpenses();
            },
            weeklyPostDeprecationValue() {
                return this.$store.state.results.getWeeklyPostDeprecation();
            },
            weeklyPostNetTaxableAmountValue() {
                return this.$store.state.results.getWeeklyPostNetTaxableAmount();
            },
            weeklyPostTaxRebateValue() {
                return this.$store.state.results.getWeeklyPostTaxRebate();
            },
            weeklyPostCashflowEstimateValue() {
                return this.$store.state.results.getWeeklyPostCashflowEstimate();
            },
            annualRentalIncomeValue() {
                return this.$store.state.results.getAnnualRentalIncome();
            },
            annualPreTotalExpensesValue() {
                return this.$store.state.results.getAnnualPreTotalExpenses();
            },
            annualPreCashflowEstimateValue() {
                return this.$store.state.results.getAnnualPreCashflowEstimate();
            },
            annualPostTotalClaimableExpensesValue() {
                return this.$store.state.results.getAnnualPostTotalClaimableExpenses();
            },
            annualPostDeprecationValue() {
                return this.$store.state.results.getAnnualPostDeprecation();
            },
            annualPostNetTaxableAmountValue() {
                return this.$store.state.results.getAnnualPostNetTaxableAmount();
            },
            annualPostTaxRebateValue() {
                return this.$store.state.results.getAnnualPostTaxRebate();
            },
            annualPostCashflowEstimateValue() {
                return this.$store.state.results.getAnnualPostCashflowEstimate();
            },
            phoneNumber() {
                return this.$store.state.phone;
            },
            email() {
                return this.$store.state.email;
            },
            name() {
                return this.$store.state.name;
            },
            userType() {
                return this.$store.state.userType;
            },
            isModalVisible() {
                return this.$store.state.isModalVisible;
            },
            wantsContact() {
                return this.$store.state.wantsContact;
            },
            printSrc() {
                var weeklyPreCashflowEstimate = this.weeklyPreCashflowEstimateValue.toLocaleString('en-US',{useGrouping:true});
                if (weeklyPreCashflowEstimate.includes('-')) {
                    weeklyPreCashflowEstimate = weeklyPreCashflowEstimate.slice(0, 1) + '$' + weeklyPreCashflowEstimate.slice(1, weeklyPreCashflowEstimate.length);
                } else {
                    weeklyPreCashflowEstimate = "$" + weeklyPreCashflowEstimate;
                }
                var weeklyPostNetTaxableAmount = this.weeklyPostNetTaxableAmountValue.toLocaleString('en-US',{useGrouping:true});
                if (weeklyPostNetTaxableAmount.includes('-')) {
                    weeklyPostNetTaxableAmount = weeklyPostNetTaxableAmount.slice(0, 1) + '$' + weeklyPostNetTaxableAmount.slice(1, weeklyPostNetTaxableAmount.length);
                } else  {
                    weeklyPostNetTaxableAmount = "$" + weeklyPostNetTaxableAmount
                }
                var weeklyPostTaxRebate = this.weeklyPostTaxRebateValue.toLocaleString('en-US',{useGrouping:true});
                if (weeklyPostTaxRebate.includes('-')) {
                    weeklyPostTaxRebate = weeklyPostTaxRebate.slice(0, 1) + '$' + weeklyPostTaxRebate.slice(1, weeklyPostTaxRebate.length);
                } else  {
                    weeklyPostTaxRebate = "$" + weeklyPostTaxRebate
                }
                var weeklyPostCashflowEstimate = this.weeklyPostCashflowEstimateValue.toLocaleString('en-US',{useGrouping:true});
                if (weeklyPostCashflowEstimate.includes('-')) {
                    weeklyPostCashflowEstimate = weeklyPostCashflowEstimate.slice(0, 1) + '$' + weeklyPostCashflowEstimate.slice(1, weeklyPostCashflowEstimate.length);
                } else  {
                    weeklyPostCashflowEstimate = "$" + weeklyPostCashflowEstimate
                }
                var annualPreCashflowEstimate = this.annualPreCashflowEstimateValue.toLocaleString('en-US',{useGrouping:true});
                if (annualPreCashflowEstimate.includes('-')) {
                    annualPreCashflowEstimate = annualPreCashflowEstimate.slice(0, 1) + '$' + annualPreCashflowEstimate.slice(1, annualPreCashflowEstimate.length);
                } else  {
                    annualPreCashflowEstimate = "$" + annualPreCashflowEstimate
                }
                var annualPostNetTaxableAmount = this.annualPostNetTaxableAmountValue.toLocaleString('en-US',{useGrouping:true});
                if (annualPostNetTaxableAmount.includes('-')) {
                    annualPostNetTaxableAmount = annualPostNetTaxableAmount.slice(0, 1) + '$' + annualPostNetTaxableAmount.slice(1, annualPostNetTaxableAmount.length);
                } else  {
                    annualPostNetTaxableAmount = "$" + annualPostNetTaxableAmount
                }
                var annualPostTaxRebate = this.annualPostTaxRebateValue.toLocaleString('en-US',{useGrouping:true});
                if (annualPostTaxRebate.includes('-')) {
                    annualPostTaxRebate = annualPostTaxRebate.slice(0, 1) + '$' + annualPostTaxRebate.slice(1, annualPostTaxRebate.length);
                } else  {
                    annualPostTaxRebate = "$" + annualPostTaxRebate
                }
                var annualPostCashflowEstimate = this.annualPostCashflowEstimateValue.toLocaleString('en-US',{useGrouping:true});
                if (annualPostCashflowEstimate.includes('-')) {
                    annualPostCashflowEstimate = annualPostCashflowEstimate.slice(0, 1) + '$' + annualPostCashflowEstimate.slice(1, annualPostCashflowEstimate.length);
                } else  {
                    annualPostCashflowEstimate = "$" + annualPostCashflowEstimate
                }

                return "/index.php/wp-json/cashflow-calculator/cashflow-calculator-print-view?" +
                    "calculator_path=" + this.$route.path + "&" +
                    "name=" + this.name + "&email=" + this.email + "&phone=" + this.phoneNumber +
                    "&user_type=" + this.userType + "&" +
                    "weekly_rental_income=" + '$' + this.weeklyRentalIncomeValue.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "weekly_pre_total_expenses=" + '$' + this.weeklyPreTotalExpensesValue.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "weekly_pre_cashflow_estimate=" + weeklyPreCashflowEstimate + "&" +
                    "weekly_post_total_claimable_expenses=" + '$' + this.weeklyPostTotalClaimableExpensesValue.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "weekly_post_depreciation=" + '$' + this.weeklyPostDeprecationValue.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "weekly_post_net_taxable_amount=" + weeklyPostNetTaxableAmount + "&" +
                    "weekly_post_tax_rebate=" + weeklyPostTaxRebate + "&" +
                    "weekly_post_cashflow_estimate=" + weeklyPostCashflowEstimate + "&" +
                    "annual_rental_income=" + '$' + this.annualRentalIncomeValue.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "annual_pre_total_expenses=" + '$' + this.annualPreTotalExpensesValue.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "annual_pre_cashflow_estimate=" + annualPreCashflowEstimate + "&" +
                    "annual_post_total_claimable_expenses=" + '$' + this.annualPostTotalClaimableExpensesValue.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "annual_post_depreciation=" + '$' + this.annualPostDeprecationValue.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "annual_post_net_taxable_amount=" + annualPostNetTaxableAmount + "&" +
                    "annual_post_tax_rebate=" + annualPostTaxRebate + "&" +
                    "annual_post_cashflow_estimate=" + annualPostCashflowEstimate + "&" +
                    "capital_growth=" + this.capitalGrowthValue + '%' + "&" +
                    "property_value_year1=" + '$' + this.propertyValueYear1.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "loan_year1=" + '$' + this.loanValueYear1.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "total_equity_year1=" + '$' + this.totalEquityValueYear1.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "property_value_year2=" + '$' + this.propertyValueYear2.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "loan_year2=" + '$' + this.loanValueYear2.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "total_equity_year2=" + '$' + this.totalEquityValueYear2.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "property_value_year3=" + '$' + this.propertyValueYear3.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "loan_year3=" + '$' + this.loanValueYear3.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "total_equity_year3=" + '$' + this.totalEquityValueYear3.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "property_value_year4=" + '$' + this.propertyValueYear4.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "loan_year4=" + '$' + this.loanValueYear4.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "total_equity_year4=" + '$' + this.totalEquityValueYear4.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "property_value_year5=" + '$' + this.propertyValueYear5.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "loan_year5=" + '$' + this.loanValueYear5.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "total_equity_year5=" + '$' + this.totalEquityValueYear5.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "property_value_year6=" + '$' + this.propertyValueYear6.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "loan_year6=" + '$' + this.loanValueYear6.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "total_equity_year6=" + '$' + this.totalEquityValueYear6.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "property_value_year7=" + '$' + this.propertyValueYear7.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "loan_year7=" + '$' + this.loanValueYear7.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "total_equity_year7=" + '$' + this.totalEquityValueYear7.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "property_value_year8=" + '$' + this.propertyValueYear8.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "loan_year8=" + '$' + this.loanValueYear8.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "total_equity_year8=" + '$' + this.totalEquityValueYear8.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "property_value_year9=" + '$' + this.propertyValueYear9.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "loan_year9=" + '$' + this.loanValueYear9.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "total_equity_year9=" + '$' + this.totalEquityValueYear9.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "property_value_year10=" + '$' + this.propertyValueYear10.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "loan_year10=" + '$' + this.loanValueYear10.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "total_equity_year10=" + '$' + this.totalEquityValueYear10.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "property_value_year11=" + '$' + this.propertyValueYear11.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "loan_year11=" + '$' + this.loanValueYear11.toLocaleString('en-US',{useGrouping:true}) + "&" +
                    "total_equity_year11=" + '$' + this.totalEquityValueYear11.toLocaleString('en-US',{useGrouping:true});
            },
            propertyValueYear1() {
                return this.$store.state.results.getPropertyValueYear1();
            },
            loanValueYear1() {
                return this.$store.state.results.getLoanYear1();
            },
            totalEquityValueYear1() {
                return this.$store.state.results.getTotalEquityYear1();
            },
            propertyValueYear2() {
                return this.$store.state.results.getPropertyValueYear2();
            },
            loanValueYear2() {
                return this.$store.state.results.getLoanYear2();
            },
            totalEquityValueYear2() {
                return this.$store.state.results.getTotalEquityYear2();
            },
            propertyValueYear3() {
                return this.$store.state.results.getPropertyValueYear3();
            },
            loanValueYear3() {
                return this.$store.state.results.getLoanYear3();
            },
            totalEquityValueYear3() {
                return this.$store.state.results.getTotalEquityYear3();
            },
            propertyValueYear4() {
                return this.$store.state.results.getPropertyValueYear4();
            },
            loanValueYear4() {
                return this.$store.state.results.getLoanYear4();
            },
            totalEquityValueYear4() {
                return this.$store.state.results.getTotalEquityYear4();
            },
            propertyValueYear5() {
                return this.$store.state.results.getPropertyValueYear5();
            },
            loanValueYear5() {
                return this.$store.state.results.getLoanYear5();
            },
            totalEquityValueYear5() {
                return this.$store.state.results.getTotalEquityYear5();
            },
            propertyValueYear6() {
                return this.$store.state.results.getPropertyValueYear6();
            },
            loanValueYear6() {
                return this.$store.state.results.getLoanYear6();
            },
            totalEquityValueYear6() {
                return this.$store.state.results.getTotalEquityYear6();
            },
            propertyValueYear7() {
                return this.$store.state.results.getPropertyValueYear7();
            },
            loanValueYear7() {
                return this.$store.state.results.getLoanYear7();
            },
            totalEquityValueYear7() {
                return this.$store.state.results.getTotalEquityYear7();
            },
            propertyValueYear8() {
                return this.$store.state.results.getPropertyValueYear8();
            },
            loanValueYear8() {
                return this.$store.state.results.getLoanYear8();
            },
            totalEquityValueYear8() {
                return this.$store.state.results.getTotalEquityYear8();
            },
            propertyValueYear9() {
                return this.$store.state.results.getPropertyValueYear9();
            },
            loanValueYear9() {
                return this.$store.state.results.getLoanYear9();
            },
            totalEquityValueYear9() {
                return this.$store.state.results.getTotalEquityYear9();
            },
            propertyValueYear10() {
                return this.$store.state.results.getPropertyValueYear10();
            },
            loanValueYear10() {
                return this.$store.state.results.getLoanYear10();
            },
            totalEquityValueYear10() {
                return this.$store.state.results.getTotalEquityYear10();
            },
            propertyValueYear11() {
                return this.$store.state.results.getPropertyValueYear11();
            },
            loanValueYear11() {
                return this.$store.state.results.getLoanYear11();
            },
            totalEquityValueYear11() {
                return this.$store.state.results.getTotalEquityYear11();
            }
        },
        methods: {
            closeModal: function () {
                this.modalVisible = false;
            },
            activeChoiceOne: function () {
                this.isActiveOne = true;
                this.isActiveTwo = false;
            },
            activeChoiceTwo: function () {
                this.isActiveOne = false;
                this.isActiveTwo = true;
            },
            calcCapitalGrowthValue: function (capitalGrowth) {
                this.$store.commit('capitalGrowthValueCalc', capitalGrowth);
            }
        }
    }
</script>

<style scoped>

    #results {
        overflow: auto;
    }

    .cashflow-estimate-header {
        margin-bottom: 0;
    }

    .calc-col-one, .calc-col-two {
        margin-top: 30px;
    }

    .annual-weekly-button-group {
        margin-bottom: 30px !important;
    }

    .equity-growth-header {
        margin-bottom: 30px;
    }

    iframe {
        visibility: hidden;
    }

    @media (max-width: 1024px) {
        .equity-growth-header {
            margin-bottom: 30px;
            margin-top: 30px;
        }
    }

    .equity-growth-table {
        margin-bottom: 15px !important;
    }

    @media (min-width: 1024px) {

        .calc-row {
            margin-top: 0;
        }

        .calc-col-one {
            width: 48%;
            float: left;
            margin-bottom: 30px;
        }

        .calc-col-two {
            width: 48%;
            float: right;
            height: 100%;
        }

        .calc-col-three {
            width: 88%;
            margin: 0 auto;
            margin-bottom: 5%;
        }

        .capital-growth {
            width: 78%;
            margin-left: auto;
            margin-right: auto;
        }

        .row-divider {
            clear: both;
        }

        .calc-flex-col {
            display: -webkit-box;
            display: -moz-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -webkit-box-orient: vertical;
            -moz-box-orient: vertical;
            -webkit-flex-direction: column;
            -ms-flex-direction: column;
            flex-direction: column;
        }

        .btn-group {
            height: 40px;
            width: 75%;
        }

        .btn {
            width: 50%;
            font-weight: bold;
        }
    }

    .blur {
        filter: blur(5px);
        -webkit-filter: blur(5px);
        pointer-events: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .btn {
        border: 1px solid rgb(206, 212, 218);
        font-size: 16px;
        padding: 1px 17.5px 3px 17.5px;
        color: #465978;
        white-space: normal;
    }

    .btn-group {
        width: 70%;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-bottom: 15px;
    }

    .button-group-two {
        width: 70%;
        margin: 0 auto;
        overflow: hidden;
    }

    .active-button {
        background-color: #465978;
        color: #fff;
    }
    
    @media (max-width: 1023px) {
        .btn {
            padding-top: 3px;
        }
    }

    @media print {
        #results {
            overflow: visible;
        }

        .first-box {
            display: none;
        }

        .show-print {
            display: block !important;
        }

        .hide-print {
            display: none !important;
        }

        iframe {
            visibility: visible;
            position: relative !important;
            display: block !important;
            border: none !important;
            width: 100vw !important;
            height: 700px !important;
            overflow: visible !important;
        }
    }

    .invisible-template {
        visibility: hidden !important;
    }

</style>


// WEBPACK FOOTER //
// src/Components/Results.vue